/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SearchFolder({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.1} d="M14.666 12.667A1.333 1.333 0 0 1 13.333 14H2.666a1.334 1.334 0 0 1-1.333-1.333V3.333A1.333 1.333 0 0 1 2.666 2H6l1.333 2h6a1.333 1.333 0 0 1 1.333 1.333z" /><path fill="currentColor" d="M7.5 6.5a2 2 0 0 1 1.415 3.413 2.001 2.001 0 0 1-2.829-2.828A2 2 0 0 1 7.501 6.5m0 4.999c.648 0 1.248-.207 1.739-.553l1.41 1.409a.5.5 0 0 0 .706 0 .5.5 0 0 0 0-.706l-1.41-1.41A2.999 2.999 0 0 0 7.501 5.5a3 3 0 0 0-3.001 3 3 3 0 0 0 3 2.999" /></svg>;
}
;